import { useState, useEffect } from "react";

const useSpeechRecognition = ({
  onEndSpeechRecognition = () => console.log("not provided"),
}) => {
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [recognition, setRecognition] = useState(null);
  const [isBrowserCompatible, setIsBrowserCompatible] = useState(false);
  const [isSecureProtocol, setIsSecureProtocol] = useState(false);

  useEffect(() => {
    if (recognition) {
      recognition.onresult = handleRecognitionResult;
    }
  }, [isListening]);

  useEffect(() => {
    const initializeRecognition = () => {
      // added on 02/07/24 for BugId 147981
      const currProtocol = window.location.protocol;
      if (currProtocol === "https:") {
        const SpeechRecognition =
          window.SpeechRecognition || window.webkitSpeechRecognition;
        const recognition = SpeechRecognition ? new SpeechRecognition() : null;
        if (recognition) {
          recognition.lang = "en-US";
          recognition.continuous = true;
          recognition.interimResults = true;
          recognition.onresult = handleRecognitionResult;
          recognition.onerror = handleRecognitionError;
          recognition.onend = handleRecognitionEnd;
          setRecognition(recognition);
          setIsBrowserCompatible(true);
        } else {
          setIsBrowserCompatible(false);
        }
        setIsSecureProtocol(true);
      } else {
        setIsSecureProtocol(false);
      }
      // till here BugId 147981
    };
    initializeRecognition();
  }, []);

  const handleRecognitionResult = (event) => {
    if (isListening) {
      let combinedTranscript = "";
      for (let i = 0; i < event.results.length; i++) {
        const transcript = event.results[i][0].transcript || "";
        combinedTranscript += transcript + " ";
      }
      setTranscript(combinedTranscript.trim());
      console.log("Final transcript:", combinedTranscript.trim());
    }
  };

  const handleRecognitionError = (event) => {
    console.error("Speech recognition error:", event.error);
  };

  const handleRecognitionEnd = () => {
    console.log("Speech recognition ended", isListening);
    setIsListening(false);
    recognition?.stop();
    if (typeof onEndSpeechRecognition === "function") {
      onEndSpeechRecognition();
    }
  };

  const toggleListen = () => {
    if (recognition) {
      if (!isListening) {
        recognition.stop();
        recognition.start();
      } else {
        recognition.stop();
        if (typeof onEndSpeechRecognition === "function") {
          onEndSpeechRecognition();
        }
      }
      setIsListening(!isListening);
    }
  };
  return {
    isBrowserCompatible,
    isSecureProtocol,
    isListening,
    transcript,
    toggleListen,
  };
};

export default useSpeechRecognition;
